import {Injectable}                  from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {Property, YesOrNo, Activity} from "./properties.models";
import {Platform}                    from '../../shared/api/messagecentrals/proxy/platforms/api.models';



@Injectable()
export class Properties {
    protected profile: BehaviorSubject<Property[]>;
    protected profileObservable: Observable<Property[]>;

    protected profileGroup: BehaviorSubject<Property[]>;
    protected profileGroupObservable: Observable<Property[]>;

    constructor() {
        this.profile           = new BehaviorSubject([]);
        this.profileObservable = this.profile.asObservable();

        this.profileGroup           = new BehaviorSubject([]);
        this.profileGroupObservable = this.profileGroup.asObservable();
    }

    getProfileProperties(): Observable<Property[]> {
        if (this.profile.getValue().length === 0) {
            this.profile.next(this.buildProfileProperties());
        }

        return this.profileObservable;
    }

    getProfileGroupProperties(platforms: Platform[]): Observable<Property[]> {
        if (this.profileGroup.getValue().length === 0) {
            this.profileGroup.next(this.buildProfileGroupProperties(platforms));
        }

        return this.profileGroupObservable;
    }

    protected buildProfileProperties(): Property[] {
        var properties = [] as Property[];

        properties.push({
            field  : 'countryCode',
            values : [
                {
                    id : 'nl',
                    label : 'nl'
                },
                {
                    id : 'be',
                    label : 'be'
                }
            ]
        });

        properties.push(new YesOrNo('hasPaid'));
        properties.push(new YesOrNo('hasPhoto'));
        properties.push(new YesOrNo('hasText'));
        properties.push(new YesOrNo('isMailable'));
        properties.push(new YesOrNo('hasCredits'));

        return properties;
    }

    protected buildProfileGroupProperties(platforms: Platform[]): Property[] {
        var properties = [] as Property[];
        let values     = [];

        platforms.forEach((platform: Platform) => {
            values.push({id: platform.id, label: platform.name});
        });

        properties.push({
            field: 'platform',
            values: values
        });

        properties.push(new Activity('activatedOnPlatform'));
        properties.push(new Activity('lastActivity'));
        properties.push({
            field : 'averagePaidMessagesSentPerWeek',
            values : [
                {
                    id : '0',
                    label : 'No paid messages per week'
                },
                {
                    id : '1-5',
                    label : 'Between 1 and 5 paid messages per week'
                },
                {
                    id : '6-15',
                    label : 'Between 6 and 15 paid messages per week'
                },
                {
                    id : '16-30',
                    label : 'Between 16 and 30 paid messages per week'
                },
                {
                    id : '>30',
                    label : 'More than 30 paid messages per week'
                }
            ]
        });

        properties.push({
            field : 'ageGroup',
            values : [
                {
                    id : '18-25',
                    label : 'Between 18 and 25 years old'
                },
                {
                    id : '26-35',
                    label : 'Between 26 and 35 years old'
                },
                {
                    id : '36-45',
                    label : 'Between 36 and 45 years old'
                },
                {
                    id : '46-55',
                    label : 'Between 46 and 55 years old'
                },
                {
                    id : '>55',
                    label : 'More than 55 years old'
                }
            ]
        });

        properties.push({
            field  : 'device',
            values : [
                {
                    id : 'mobile',
                    label : 'Mobile'
                },
                {
                    id : 'tablet',
                    label : 'Tablet'
                },
                {
                    id : 'desktop',
                    label : 'Desktop'
                }
            ]
        });

        properties.push({
           field  : 'ipLevel',
           values : [
               {
                   id : '1',
                   label: 'Level one'
               },
               {
                   id : '2',
                   label: 'Level two'
               },
               {
                   id : '>2',
                   label: 'The rest'
               }
           ]
        });

        properties.push({
            field  : 'engagementLevel',
            values : [
                {
                    id : 'zombie_user',
                    label: 'Zombie (Level 0)'
                },
                {
                    id : 'dead_user',
                    label: 'Dead (Level 1)'
                },
                {
                    id : 'inactive_user',
                    label: 'Inactive User (Level 2)'
                },
                {
                    id : 'active_user',
                    label: 'Active User (Level 3)'
                },
                {
                    id : 'engaged_user',
                    label: 'Engaged User (Level 4)'
                },
                {
                    id : 'paid_user',
                    label: 'Paying User (Level 5)'
                },
                {
                    id : 'new_user',
                    label: 'New User (Level 6)'
                },
            ]
        });

        return properties;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/properties.service.ts